import { render } from "./Table.vue?vue&type=template&id=02c69664"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
script.render = render

export default script